module.exports = __webpack_public_path__ + "static/media/yt.df07f051.svg";